import AboutLayout from "./AboutLayout";
import PrincipalImg from "../../utils/images/principl.PNG";

function PrincipalMessage() {
  return (
    <AboutLayout
      title="Principal's Message"
      image={PrincipalImg}
      name="Mohammad Sabir"
      designation="Principal"
    >
      <p>Dear Parents,</p>

      <p>
        At IQRAA Public School, we are passionate about creating a nurturing
        environment where every student can thrive. Our mission is to cultivate
        a love for learning, encourage critical thinking, and develop
        responsible global citizens. We understand that education is the
        foundation of a successful life, and our dedicated staff works
        tirelessly to ensure each student reaches their full potential.
      </p>

      <p>
        Together with the support of parents and guardians, we are building a
        community that values growth, innovation, and the pursuit of excellence.
      </p>
    </AboutLayout>
  );
}

export default PrincipalMessage;
